import { AccredibleSeoService } from '@accredible-frontend-v2/services/seo';
import { Component, inject, OnInit } from '@angular/core';

@Component({
  templateUrl: './page-not-found.container.html',
  styleUrls: [`./page-not-found.container.scss`],
})
export class PageNotFoundContainer implements OnInit {
  private readonly _seo = inject(AccredibleSeoService);

  ngOnInit(): void {
    this._seo.generateTags();
  }
}
